import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { ExamService } from "src/app/services/exam.service";
import { CustomValidators } from "src/app/validators/custom.validators";
import { Exam } from "src/app/models/exam";
import { Config } from "src/app/config";

@Component({
  templateUrl: "./examproperties.component.html",
})
export class ExamPropertiesComponent {
  form: FormGroup;
  exam: Exam;
  // Only this brand's styles: the look follows the host, never another brand's.
  styles = Config.BRANDS[Config.BRAND].styles;

  constructor(private fb: FormBuilder, private examService: ExamService) {
    this.exam = this.examService.currentExam;

    this.form = this.fb.group({
      name: [this.exam.name, [Validators.required, Validators.maxLength(100)]],
      description: [this.exam.description, [Validators.required, Validators.maxLength(200)]],
      order: [this.exam.order, [Validators.required, CustomValidators.integer]],
      enable: [this.exam.enable, [Validators.required]],
      pageWidth: [this.exam.pageWidth, [Validators.required, CustomValidators.integer]],
      pageHeight: [this.exam.pageHeight, [Validators.required, CustomValidators.integer]],
      style: [this.exam.style, [Validators.required]],
      disableSubmit: [this.exam.disableSubmit, [Validators.required]],
    });
  }

  hasErrors(): boolean {
    return this.form.invalid;
  }

  get values(): any {
    return this.form.value;
  }

  get onFormStatusChanges(): Observable<boolean> {
    return this.form.statusChanges.pipe(map(status => status == "INVALID"));
  }
}
